export const INDICES_URL = '/content-service/market-indices';
export const GET_MARKET_INDICES = 'news/GET_MARKET_INDICES';
export const GET_MARKET_INDICES_SUCCESS = 'news/GET_MARKET_INDICES_SUCCESS';
export const GET_MARKET_INDICES_FAIL = 'news/GET_MARKET_INDICES_FAIL';
